import {
  ADD_QUESTIONNAIRE,
  EDIT_QUESTIONNAIRE,
  LIST_QUESTIONNAIRE,
  VIEW_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE,
  ADD_QUESTIONNAIRE_TEXT,
  EDIT_QUESTIONNAIRE_TEXT,
  LIST_QUESTIONNAIRE_TEXT,
  VIEW_QUESTIONNAIRE_TEXT,
  DELETE_QUESTIONNAIRE_TEXT,
  QUESTIONNAIRE_SUCCESS,
  QUESTIONNAIRE_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const Questionnaire = (state = initialState, action) => {
  switch (action.type) {

    // add questionnaire
    case ADD_QUESTIONNAIRE:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case QUESTIONNAIRE_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case QUESTIONNAIRE_ERROR:
      state = { ...state, error: action.payload, loading: false, editLoading:false}
      break

    // edit questionnaire
    case EDIT_QUESTIONNAIRE:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list questionnaire
    case LIST_QUESTIONNAIRE:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view questionnaire
    case VIEW_QUESTIONNAIRE:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete questionnaire
    case DELETE_QUESTIONNAIRE:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add questionnaire
    case ADD_QUESTIONNAIRE_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case QUESTIONNAIRE_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case QUESTIONNAIRE_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit questionnaire
    case EDIT_QUESTIONNAIRE_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list questionnaire
    case LIST_QUESTIONNAIRE_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view questionnaire
    case VIEW_QUESTIONNAIRE_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete questionnaire
    case DELETE_QUESTIONNAIRE_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default Questionnaire
